import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { GarageFlowLogo } from "@/components/Brand";
import { useAuth, homePathFor } from "@/context/AuthContext";
import { t } from "@/i18n";

export function PublicHeader() {
  const { me } = useAuth();
  return (
    <header className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-6">
      <GarageFlowLogo />
      <nav className="flex items-center gap-2 sm:gap-4">
        <Link to="/pricing" className="text-sm font-medium text-slate-700 transition-colors duration-200 hover:text-[#0A2540]" data-testid="header-pricing-link">{t("p7.pricing.nav")}</Link>
        {!me && <Link to="/login" className="hidden text-sm font-medium text-slate-700 hover:text-[#0A2540] sm:inline" data-testid="header-login-link">{t("landing.signIn")}</Link>}
        <Button asChild data-testid="header-cta-button">
          <Link to={me ? homePathFor(me) : "/signup"}>{me ? t("landing.openApp") : t("p7.pricing.startTrial")}</Link>
        </Button>
      </nav>
    </header>
  );
}
